const nunjucks = window.nunjucks;
export default nunjucks;